/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      // console.log(
      //   'App is being served from cache by a service worker.\n' +
      //   'For more details, visit https://goo.gl/AFskqB'
      // )
    },
    registered () {
      // console.log('Service worker has been registered.')
    },
    cached () {
      // console.log('Content has been cached for offline use.')
    },
    updatefound () {
      // console.log('New content is downloading.')
    },
    updated () {
      // A new version was deployed and (with skipWaiting) the new service worker has taken over.
      // Reload ONCE so the page uses the fresh index.html + chunks instead of the previous version's
      // now-deleted files — this is what stops the "Unexpected token '<'" blank page after a deploy.
      if (!window.__busySwReloaded) {
        window.__busySwReloaded = true
        window.location.reload()
      }
    },
    offline () {
      // console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
